import React from "react";
import { Calendar, MapPin, AlertCircle, ChevronRight } from "lucide-react";

const TWorkOrderCard = ({ repairInfo, reportingDate, onView }) => {
  // Check if the status is "Pending"
  if (repairInfo?.status?.toLowerCase() !== "pending") {
    return null;
  }

  const assetName = repairInfo?.assetName;
  const area = repairInfo?.area;
  const priority = repairInfo?.priority;

  const getPriorityStyles = (priority) => {
    const priorityLower = priority?.toLowerCase();
    switch (priorityLower) {
      case "immediate":
        return "bg-zinc-900 text-white";
      case "high":
        return "bg-zinc-800 text-white";
      case "moderate":
        return "bg-zinc-700 text-white";
      case "low":
        return "bg-zinc-100 text-zinc-900";
      default:
        return "bg-zinc-100 text-zinc-900";
    }
  };

  return (
    <div
      className="bg-white border border-zinc-200 rounded-lg p-5 hover:shadow-md transition-shadow cursor-pointer group"
      onClick={onView}
    >
      <div className="flex items-start justify-between mb-4">
        <h3 className="text-base font-semibold text-zinc-900 line-clamp-2 flex-1">
          {assetName}
        </h3>
        <ChevronRight className="w-5 h-5 text-zinc-400 group-hover:text-zinc-600 transition-colors flex-shrink-0 ml-2" />
      </div>

      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2 text-sm text-zinc-600">
          <Calendar className="w-4 h-4 text-zinc-400" />
          <span>{reportingDate || "N/A"}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-zinc-600">
          <MapPin className="w-4 h-4 text-zinc-400" />
          <span>{area || "N/A"}</span>
        </div>
      </div>

      <div className="flex items-center justify-between mt-4 pt-4 border-t border-zinc-100">
        {priority && (
          <span
            className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-xs font-medium ${getPriorityStyles(
              priority,
            )}`}
          >
            <AlertCircle className="w-3 h-3" />
            {priority}
          </span>
        )}
        <button
          onClick={(e) => {
            e.stopPropagation();
            onView();
          }}
          className="text-sm font-medium text-zinc-900 hover:text-zinc-700 transition-colors"
          style={{
            backgroundColor: "rgb(48 88 69 / var(--tw-bg-opacity, 1))",
            color: "white",
          }}
        >
          View details
        </button>
      </div>
    </div>
  );
};

export default TWorkOrderCard;
